import { render, staticRenderFns } from "./TestimonialCard.vue?vue&type=template&id=230ac40a&scoped=true"
import script from "./TestimonialCard.vue?vue&type=script&lang=ts"
export * from "./TestimonialCard.vue?vue&type=script&lang=ts"
import style0 from "./TestimonialCard.vue?vue&type=style&index=0&id=230ac40a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230ac40a",
  null
  
)

export default component.exports